import type { MutationFunction } from "@tanstack/react-query";
import { type HTTPResponse, useHTTP, useHTTPMutation } from "@/lib/http";
import type { Currency } from "@/lib/domain/Currency";

export interface RegisterRequestModel {
	readonly emailAddress: string;
	readonly password: string;
	readonly displayName: string;
	readonly preferredCurrency: Currency;
	readonly registerPassword: string | null;
	readonly attribution: string | null;
}

export interface RegisterResponseModel {
	readonly userId: string;
}

export const useRegister = () => {
	const http = useHTTP("None");

	const mutationFn: MutationFunction<HTTPResponse<RegisterResponseModel>, RegisterRequestModel> = requestModel => {
		return http<RegisterResponseModel, RegisterRequestModel>({
			method: "POST",
			url: "/auth/register",
			body: requestModel
		});
	};

	return useHTTPMutation({ mutationFn });
};
